export enum ProgramRequestType {
    /**
     * Mišljenje za novi program (ASOO)
     */
    OpinionForTheNewProgramASOO = 1,
    /**
     * Izvođenje za novi program (MZO)
     */
    ImplementationForANewProgramMZO = 2,
    /**
     * Suglasnost za usklađivanje (ASOO)
     */
    ConsentForHarmonizationASOO = 3,
    /**
     * Suglasnost za usklađivanje (MZO)
     */
    // ConsentForHarmonizationMZO = 4,
    /**
     * Suglasnost za izvođenje na lokaciji druge pravne osobe (MZO)
     */
    ConsentForExecutionAtTheLocationOfAnotherLegalEntityMZO = 5,
    /**
     * Suglasnost za izvođenje na stranom jeziku (MZO)
     */
    ConsentForExecutionInAForeignLanguage = 6,
    /** 
     * Zahtjev za izvođenje na drugoj lokaciji
     */
    RequestForExecutionAtAnotherLocation = 7,
    InstitutionBasicDataChange = 8
}
